import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImageGallery from 'react-image-gallery';
import styled from 'styled-components';
import * as userActions from '../store/actions';
import queryString from 'query-string';
import { Cart, Page, Button, ItemPage, Spinner, Select, Splitter } from '../common';
import {
    Balance,
    BalanceMobileActions,
} from '../common/Balance';
import {
    DesktopFilterToolbar,
    DesktopFilters,
    MobileFilterToolbar,
    TitleContainer,
    Title,
} from './Shop';
import { useFetch } from '../common/hooks';
import { getLangValue, getImageValue, formatCurrency } from '../common/functions';
import { ProductOption } from './ProductOption';
import config from '../config';

const Product = ({
    history,
    location,
    match: { params: { slug, id } },
    userActions: { addItem, updateCart, saveShopCart },
    user: { accounts, authenticated, cart, claimPrize }
}) => {
    const [balance, setBalance] = useState(null);
    const { lottery } = queryString.parse(location.search);
    const [{ data, loading }] = useFetch(`${config.backendAddress}/api/v1/shop/products/${id}`);
    const [option, setOption] = useState(null);

    useEffect(() => {
        const winsAccountsSaldo = accounts.reduce((acc, cur) => {
            // Include wins, shop currency, extra wins
            if(['wins', 'bonus', 'extra_wins'].indexOf(cur.variety) !== -1) {
                return acc + cur.saldo;
            }
            return acc;
        }, 0);
        const saldo = winsAccountsSaldo;
        setBalance(saldo);
    }, [accounts]);

    if (!data || (claimPrize && data.value !== claimPrize)) {
        return <></>;
    }

    return (
        <Page>
            <DesktopFilterToolbar className='filter-toolbar'>

                <DesktopFilters className='desktop-filters'>

                    <Page.BackButton
                        onClick={() => history.push(slug ? `/${slug}/voittokauppa` : '/voittokauppa')}
                        text='Takaisin'
                    />

                    <TitleContainer>
                        <Title>Voiton tiedot</Title>

                    </TitleContainer>

                    <Splitter />
                    {authenticated && (
                        <Cart
                            items={cart.items}
                            reverse
                            onCartClick={() => history.push('/ostoskori')}
                            style={{ marginLeft: '40px', marginRight: '60px' }}
                        />
                    )}
                    <Splitter />
                    {
                        authenticated ? (
                            <Balance
                                value={balance}
                                titleText='Voittosaldosi'
                            />
                        ) : (
                            claimPrize &&
                                <Balance
                                    titleText='Lunastamaton voitto'
                                    titleWidth={'10em'}
                                    value={claimPrize}
                                />
                        )
                    }
                </DesktopFilters>
            </DesktopFilterToolbar>

            {
                authenticated ? (
                    <MobileFilterToolbar className='filter-toolbar'>
                        <BalanceMobileActions style={{ minHeight: '2em' }}>
                            <Splitter />
                            <Cart
                                items={cart.items}
                                reverse
                                onCartClick={() => history.push('/ostoskori')}
                            />
                            <Splitter />
                            <Balance value={balance}/>
                        </BalanceMobileActions>
                    </MobileFilterToolbar>

                ) : (
                    claimPrize && (
                        <MobileFilterToolbar className='filter-toolbar'>
                            <Balance titleText='Lunastamaton voitto' titleWidth={'10em'} value={claimPrize} />
                        </MobileFilterToolbar>
                    )
                )
            }


            <Page.Content flex>
                {!loading && data && (
                    <ItemPage>
                        <ImageGallery
                            showPlayButton={false}
                            showThumbnails={false}
                            items={data.images.filter((item) => item.variety == 'large').map((item) => {
                                return { original: item.source };
                            })}
                        />
                        <ItemPage.Content>
                            <ItemPage.Title>{`${data.custom_id ? `${data.custom_id}. ` : ''}${getLangValue(data.names, 'fi')}`}</ItemPage.Title>
                            <ItemPage.Description>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: getLangValue(data.descriptions, 'fi')
                                    }}
                                ></div>
                            </ItemPage.Description>
                            <ItemPage.Title style={{ marginTop: '1em' }}>Arvo {formatCurrency(data.value)} €</ItemPage.Title>
                            <ItemPage.Actions>
                                <div style={{ display: 'grid' }}>
                                    {data && data.variations.length > 0 &&
                                     (
                                         <ProductOption
                                             option={data.variations}
                                             onChange={(item) => setOption(item)}
                                         />
                                     )}

                                    {
                                        authenticated ? (
                                            <Button
                                                style={{ marginTop: '10px' }}
                                                onClick={() => {
                                                    const item = { ...data, option: option };
                                                    // Determine target lottery based on first item.
                                                    if (cart.items.length === 0) {
                                                        updateCart({
                                                            lottery_id: lottery,
                                                            items: [item]
                                                        });
                                                    } else {
                                                        addItem(item);
                                                    }

                                                    /* Saving shop cart gets us an
                                                     * order token, thus we push
                                                     * history after finishing
                                                     * saving cart. */
                                                    saveShopCart(() => history.push('/ostoskori'));
                                                }}>
                                                Lisää ostoskoriin
                                            </Button>
                                        ) : (
                                            claimPrize && (
                                                <Button
                                                    style={{ marginTop: '1em' }}
                                                    onClick={() => {
                                                        history.push(
                                                            `/lunastettavat/${config.nuorelleSiivetSlug}/pikalunastus`,
                                                            {
                                                                product: data,
                                                                option: option?.variation_id,
                                                            },
                                                        );
                                                    }}>
                                                    Lunasta
                                                </Button>
                                            )
                                        )
                                    }
                                </div>
                            </ItemPage.Actions>
                        </ItemPage.Content>
                    </ItemPage>
                )}
                {loading && <Spinner />}
            </Page.Content>
        </Page>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        userActions: bindActionCreators({ ...userActions }, dispatch)
    };
};

const ProductConnected = connect(mapStateToProps, mapDispatchToProps)(Product);

export { ProductConnected as Product };
